import React from 'react';

export default function ReportStatusAlert({ 
  reportStatus = 'no-report',
  databaseAutoFillInProgress = false,
  autoFillCheckComplete = true,
  databaseAutoFillEnabled = true,
  anyAutoFillEnabled = true,
  className = ""
}) {
  
  // Determine the status and styling
  const getStatusInfo = () => {
    // Show checking state when auto-fill check is not complete or actively in progress
    if (!autoFillCheckComplete || databaseAutoFillInProgress) {
      return {
        icon: <div className="animate-spin rounded-full h-3 w-3 border-b border-blue-600"></div>,
        text: "Checking Reports...",
        textColor: "text-blue-600"
      };
    }
    
    // Only show loading spinner for 'checking' status if autofill is actively in progress
    // If autoFillCheckComplete is true, treat 'checking' as 'no-report' for display purposes
    if (reportStatus === 'checking' && !autoFillCheckComplete) {
      return {
        icon: <div className="animate-spin rounded-full h-3 w-3 border-b border-blue-600"></div>,
        text: "Checking Reports...",
        textColor: "text-blue-600"
      };
    }
    
    switch (reportStatus) {
      case 'saved':
      case 'found':
        return {
          icon: <div className="w-3 h-3 bg-green-500 rounded-full"></div>,
          text: "Report Found",
          textColor: "text-green-600"
        };
      case 'in-progress':
        return {
          icon: <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>,
          text: "Report in Progress",
          textColor: "text-yellow-600"
        };
      case 'checking':
        // If we reach here, autofill check is complete but status is still 'checking'
        // Treat this as 'no-report' for display purposes
        return {
          icon: <div className="w-3 h-3 bg-gray-400 rounded-full"></div>,
          text: "No Report Found",
          textColor: "text-gray-600"
        };
      case 'no-report':
      default:
        return {
          icon: <div className="w-3 h-3 bg-gray-400 rounded-full"></div>,
          text: "No Report Found",
          textColor: "text-gray-600"
        };
    }
  };

  // Don't render if all auto-fill features are disabled
  if (!anyAutoFillEnabled) {
    return null;
  }
  
  // Don't render "No Report Found" if database auto-fill is disabled 
  // (since we're not checking for reports)
  if (!databaseAutoFillEnabled && (reportStatus === 'no-report' || reportStatus === 'checking')) {
    return null;
  }

  const statusInfo = getStatusInfo();

  return (
    <div className={`flex items-center gap-2 text-sm ${className}`}>
      {statusInfo.icon}
      <span className={`${statusInfo.textColor} font-medium`}>
        {statusInfo.text}
      </span>
    </div>
  );
}
